import { render, staticRenderFns } from "./greySong.vue?vue&type=template&id=63ec653a"
import script from "./greySong.vue?vue&type=script&lang=js"
export * from "./greySong.vue?vue&type=script&lang=js"
import style0 from "./greySong.vue?vue&type=style&index=0&id=63ec653a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports